import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { PageLeadDefault } from '../../_lib/components/PageLead';
import { AttributeGroupPageLeadEditForm } from './forms/AttributeGroupPageLeadEditForm';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { AttributeGroupPageLeadInteractions } from './partials/AttributeGroupPageLeadInteractions';

type AttributeGroupPageLead = Views<DefaultView<{ title: string }> & OptionalEditView<AttributeGroupPageLeadEditForm>>;

function AttributeGroupPageLead({ views, activeView }: AttributeGroupPageLead) {
  const { editModeInfo } = useAppContext();

  if (editModeInfo.active && views.edit) {
    return <AttributeGroupPageLeadInteractions views={views} activeView={activeView} />;
  }

  return <PageLeadDefault title={views.default.embedded.title} />;
}

export const AttributeGroupPageLeadBlock = asFetchableBlock(AttributeGroupPageLead, BlockType.attributegrouppagelead);
export type AttributeGroupPageLeadBlock = ComponentProps<typeof AttributeGroupPageLeadBlock>;
